import React, { useEffect } from 'react';
import { ButtonTheme, ModalButtonType, Size } from '@philips-internal/oswald-ui-constants';
import { isXSmallResolution } from '@philips-internal/oswald-ui-utils';
import { useGlobalActionsStack } from '../../../context/global-actions-stack-context.js';
import { Button } from '../../button/button.js';
function createButton(options) {
    const { action, actionWrapper, badge, className, enabled, icon, iconClassName, iconPlacement, loading, onBlur, onContextMenuClick, onDoubleClick, onFocus, preventDefault, stopPropagation, theme, title, type, } = options;
    const defaultTheme = type === ModalButtonType.SUCCESS
        ? ButtonTheme.PRIMARY
        : ButtonTheme.SECONDARY;
    return (React.createElement(Button, { badge: badge, className: className, enabled: enabled, icon: icon, iconClassName: iconClassName, iconPlacement: iconPlacement, key: title, loading: loading, onBlur: onBlur, onClick: actionWrapper(action), onContextMenuClick: onContextMenuClick, onDoubleClick: onDoubleClick, onFocus: onFocus, preventDefault: preventDefault, size: isXSmallResolution() ? Size.SMALL : Size.LARGE, stopPropagation: stopPropagation, theme: theme ?? defaultTheme, value: title }));
}
function ModalButtonDock(props) {
    const context = useGlobalActionsStack();
    useEffect(() => {
        const dockButtons = props.buttons.map(button => createButton({ ...button, actionWrapper: props.actionWrapper }));
        const popActions = context.pushActions({ actions: dockButtons });
        return popActions;
    }, [props.buttons]);
    return null;
}
export { ModalButtonDock, };
//# sourceMappingURL=modal-button-dock.js.map